import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  Link,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Backdrop,
  CircularProgress,
  Typography,
} from "@mui/material";
import FileUpload from "../../../documenti/FileUpload";
import { useState } from "react";
import { Add, Download } from "@mui/icons-material";
import { Eye } from "react-feather";
import { API_BASE_URL } from "../../../../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../redux/slices/snackbar";

const Precontrattuale = ({ data }) => {
  const [file, setFile] = useState(null);
  const [rows, setRows] = useState(data?.preC || []);
  const [loadingPage, setLoadingPage] = useState(false);

  const idUidAc = data?.idUidAc;
  const idUidS = data?.idUidS;
  const handleRowFileUpload = (idUid, files) => {
    const uploadedFile = files[0];
    setRows((prev) =>
      prev.map((row) =>
        row.idUidDocumento === idUid ? { ...row, file: uploadedFile } : row,
      ),
    );
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleSnackbar = (message, severity) => {
    dispatch(showSnackbar({ message, severity }));
  };

  const handleViewFile = (file) => {
    if (!file) {
      alert("Nessun file caricato per questo documento.");
      return;
    }

    const fileURL = URL.createObjectURL(file);
    const newWindow = window.open(fileURL, "_blank");
    newWindow?.addEventListener("unload", () => URL.revokeObjectURL(fileURL));
  };

  const AddRow = () => {
    setRows((prev) => [
      ...prev,
      {
        idUidDocumento: `new-${prev.length + 1}`,
        nome: "Nuovo Documento",
        tipo: "Opzionale",
        fonte: "Upload",
        descrizione: "",
        abilitato: 1,
        file: null,
      },
    ]);
  };

  async function handleDownloadFile(idUidAu, nome) {
    setLoadingPage(true);
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const response = await fetch(
        `${API_BASE_URL}/api/pdf/${idUidAu}/${idUidS}/${idUidAc}`,
        requestOptions,
      );
      if (response.status === 200) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = nome;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else if (response.status === 401) {
        navigate("/auth/sign-in");
      } else {
        handleSnackbar("Errore durante il download del file.", "error");
      }
      setLoadingPage(false);
    } catch (error) {
      console.log(error);
      handleSnackbar("Errore durante il download del file.", "error");
    } finally {
      setLoadingPage(false);
    }
  }

  //Fare una condizione per capire se il documento è autogenerato o file che esiste già

  /* const handleSave = async () => {
    setLoadingPage(true);
    // Error checks
    const newErrors = {
      nome: form.nome === "",
      file:
        savedIdUidFile === ""
          ? form.tipo.value === 2 && form.fonte.value === 3 && !file
          : false,
      link: form.tipo.value === 2 && form.fonte.value === 2 && !form.link,
      autoGenerato:
        form.tipo.value === 2 &&
        form.fonte.value === 1 &&
        form.autoGenerati.value === "",
    };

    setErrors(newErrors);

    // If any error, show snackbar and stop
    if (Object.values(newErrors).some(Boolean)) {
      handleSnackbar("Compila tutti i campi obbligatori.", "error");
      return;
    }

    const payload = {
      idUID: iduid,
      nome: form.nome.trim(),
      descrizione: form.descrizione.trim(),
      fonte: form.fonte.value,
      tipo: form.tipo.value,
      tipologia: form.tipologie.value,
      link: form.link.trim(),
      idUidFile: form.idUidFile,
      idAutoGenerato:
        form.autoGenerati.value === "" ? 0 : form.autoGenerati.value,
    };

    console.log(payload);

    if (rows !== undefined) {
      const documentoExists = (doc) => {
        return rows.some(
          (row) =>
            row.nome.trim().toLowerCase() === doc.nome.trim().toLowerCase()
        );
      };

      if (documentoExists(payload)) {
        handleSnackbar("Documento già esistente, cambiare il nome", "error");
        setLoadingPage(false);
        return;
      }
    }

    const formData = new FormData();
    const token = sessionStorage.getItem("token");

    formData.append("data", JSON.stringify(payload));
    formData.append("file", "");

    // Only append file if fonte === 3
    if (form.tipo.value === 2 && form.fonte.value === 3 && file) {
      formData.set("file", file);
    }

    formData.forEach((value, key) => {
      console.log(`${key}:`, value);
    });

    try {
      // Uncomment to enable API call
      const response = await fetch(`${API_BASE_URL}/api/documentiNewUpdate`, {
        method: "POST",
        headers: {
          authorization: "Bearer " + token,
        },
        body: formData,
      });

      const responseData = await response.json();

      if (responseData.status === -1) {
        navigate("/auth/sign-in");
      }
      if (responseData.status === 0) {
        handleSnackbar(responseData.message, "error");
        return;
      }
      if (responseData.status === 1) {
        handleSnackbar(responseData.message, "success");
        const documento = {
          ...payload,
          idUidDocumento: responseData.data.idUid,
          tipo: payload.tipo === 1 ? "Richiesto" : "Contratto",
          fonte:
            payload.fonte === 1
              ? "Autogenerato"
              : payload.fonte === 2
              ? "Link"
              : payload.fonte === 3
              ? "File"
              : "",
          abilitato: 0,
        };
        delete documento.idUID;

        if (addDocumentoToRows !== undefined && iduid === "") {
          if (!addDocumentoToRows(documento)) {
            setLoadingPage(false);
            return;
          }
        }
        if (modifyDocumento !== undefined && iduid !== "") {
          if (!modifyDocumento(documento)) {
            setLoadingPage(false);
            return;
          }
        }
      }
      setLoadingPage(false);
      handleClose();
      if (onRefresh) onRefresh();
    } catch (error) {
      console.log(error);
      handleSnackbar("Errore durante il salvataggio.", "error");
      setLoadingPage(false);
      handleClose();
    }
  }; */

  return (
    <Box display="flex" flexDirection="column" gap={4} width="100%">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loadingPage}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        sx={{
          maxHeight: 400,
          overflowY: "auto",
          width: "100%",
          border: "1px solid #929292ff",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Documento</TableCell>
              <TableCell align="center">Download</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((el) => (
              <TableRow key={el.idUidDocumento}>
                <TableCell>
                  <Box>
                    <Typography fontWeight="bold">{el.nome}</Typography>
                  </Box>
                  {el.descrizione && (
                    <Box sx={{ fontSize: "0.8rem", mt: 0.5 }}>
                      {el.descrizione}
                    </Box>
                  )}
                </TableCell>
                <TableCell>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap={1}
                  >
                    {el.link ? (
                      <IconButton
                        color="secondary"
                        onClick={() => window.open(el.link, "_blank")}
                      >
                        <Eye size={20} />
                      </IconButton>
                    ) : (
                      <FileUpload
                        onFileAccepted={(files) =>
                          handleRowFileUpload(el.idUidDocumento, files)
                        }
                        trigger={({ open }) => (
                          <IconButton
                            color="primary"
                            onClick={() =>
                              handleDownloadFile(el.idUidAu, el.nome)
                            }
                          >
                            <Download />
                          </IconButton>
                        )}
                      />
                    )}
                    {el.file && (
                      <Button
                        onClick={() => handleViewFile(el.file)}
                        variant="outlined"
                        size="small"
                      >
                        {el.file.name.length > 15
                          ? el.file.name.substring(0, 12) + "..."
                          : el.file.name}
                      </Button>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default Precontrattuale;
